import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Options } from 'src/app/model/options';
import { OPTIONS } from 'src/app/data/options';
import { merge } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class OptionsService {
    private _optionsSource: Subject<Options[]> = new Subject();
    private _currentOptionsState: Options[];
    options$ = this._optionsSource.asObservable();

    private activeOption: Options = null;

    get optionsSource(): Subject<Options[]> {
      return this._optionsSource;
    }
    set optionsSource(data: Subject<Options[]>) {
      this._optionsSource = data;
    }

    get currentOptionsState(): Options[] {
      return this._currentOptionsState;
    }
    set currentOptionsState(options: Options[]) {
      this._currentOptionsState = options;
    }

    get active():Options{
      
      return this.activeOption;
    }

    getPreviousOption(target:string){

      let currentStateArray=this.currentOptionsState;
      let prevOpt:Options=null;
      
      if(currentStateArray)
        for(let i=0;i<currentStateArray.length;i++){
          if(currentStateArray[i].staticName==target)
            return prevOpt
          else{          
            if(currentStateArray[i].subOptions){
              for(let j=0;j<currentStateArray[i].subOptions.length;j++){
                if(currentStateArray[i].subOptions[j].staticName==target)
                  return prevOpt
                else{

                  if(currentStateArray[i].subOptions[j].subOptions){

                    for(let k=0;k<currentStateArray[i].subOptions[j].subOptions.length;k++){

                      if(currentStateArray[i].subOptions[j].subOptions[k].staticName==target)
                        return prevOpt;
                      else
                        prevOpt=currentStateArray[i].subOptions[j].subOptions[k]       
                    }     
                  }else{
                    prevOpt=currentStateArray[i].subOptions[j];
                  }

                }
              }
            }
            prevOpt=currentStateArray[i];
            
          }
        }
      return prevOpt;
    }


    getNextOption(target:string){

      let currentStateArray=this.currentOptionsState;
      let nextOpt:Options=null;
      
      if(currentStateArray)
        for(let i=currentStateArray.length-1;i>=0;i--){
          if(currentStateArray[i].staticName==target)
            return nextOpt
          else{          
            if(currentStateArray[i].subOptions){
              for(let j=currentStateArray[i].subOptions.length-1;j>=0;j--){
                if(currentStateArray[i].subOptions[j].staticName==target)
                  return nextOpt
                else{

                  if(currentStateArray[i].subOptions[j].subOptions){

                    for(let k=currentStateArray[i].subOptions[j].subOptions.length-1;k>=0;k++){

                      if(currentStateArray[i].subOptions[j].subOptions[k].staticName==target)
                        return nextOpt;
                      else
                      nextOpt=currentStateArray[i].subOptions[j].subOptions[k]       
                    }     
                  }else{
                    nextOpt=currentStateArray[i].subOptions[j];
                  }

                }
              }
            }
            nextOpt=currentStateArray[i];
            
          }
        }
      return nextOpt;
    }


    getActionByName(target){

      let currentStateArray=this.currentOptionsState;
      
      if(currentStateArray)
        for(let i=0;i<currentStateArray.length;i++){
          if(currentStateArray[i].staticName==target)
            return currentStateArray[i];
          else{          
            if(currentStateArray[i].subOptions)
              for(let j=0;j<currentStateArray[i].subOptions.length;j++){
                if(currentStateArray[i].subOptions[j].staticName==target)
                  return currentStateArray[i].subOptions[j];
                else{
                  if(currentStateArray[i].subOptions[j].subOptions)
                    for(let k=0;k<currentStateArray[i].subOptions[j].subOptions.length;k++){
                      if(currentStateArray[i].subOptions[j].subOptions[k].staticName==target)
                        return currentStateArray[i].subOptions[j].subOptions[k];                
                    }       
                }
              }   
          }
        }
      return null;
    }


    getActive(){
      let option=this.currentOptionsState.find(_currentOptionsState => _currentOptionsState.active === true);
      let subOption=null
      let action=null

      if(option && option.subOptions)
        subOption=option.subOptions.find(_currentOptionsState => _currentOptionsState.active === true);

      if(subOption && subOption.subOptions)
        action=subOption.subOptions.find(_currentOptionsState => _currentOptionsState.active === true);      

      if(action)
        return action;
      else if(subOption)
        return subOption;
      else if(option)
        return option;
      else
        return null;      
    }

    change(target: string, field, value){
      this.currentOptionsState = OPTIONS.map( option => {
        let obj3={}
        if (option.staticName === target) {  
          obj3[field]=value;
          this.activeOption=merge({}, option, obj3)
          return merge({}, option, obj3);
        }else{        
          let isActive2=false;
          let subOptions;
          if(option.subOptions){
            subOptions= option.subOptions.map( subOption => { 
              let obj2={}
              if (subOption.staticName === target) { 
                isActive2=true;
                obj2[field]=value;
                this.activeOption=merge({}, subOption, obj2)
                return merge({}, subOption, obj2);
              }else{   
                let isActive=false;   
                let actions 
                if(subOption.subOptions){     
                  actions = subOption.subOptions.map( action => {
                    if (action.staticName === target) {  
                      let obj={}
                      obj[field]=value;
                      isActive=true;
                      isActive2=true;
                      this.activeOption=merge({}, action, obj)
                      return merge({}, action, obj);
                    }else{
                      return action;
                    }
                  
                  });
                }else{
                  actions=[];
                }
                obj2[field]=isActive;
                // isActive2=isActive;
                obj2['subOptions']=actions;
                return merge({}, subOption, obj2)
              }
            });  
          }else{
            subOptions=[];
          }      
          obj3[field]=isActive2;
          obj3['subOptions']=subOptions;
          return merge({}, option, obj3)
        }
      });
      this.optionsSource.next(this.currentOptionsState);
    }


    changeOptionsState(name: string) {
      this.changeActiveCategory(name);
    }

    private changeActiveCategory(category: string) {

      this.currentOptionsState = OPTIONS.map(element => {
        let subOptions=[];
        if(element.subOptions){
          subOptions= element.subOptions.map( tmp => {
              if (element.staticName === category) {
                  return tmp;
              }
              return merge({}, tmp, {active: false});
            });
          }
          if (element.staticName === category) {
            return merge({}, element, {active: true,subOptions:subOptions});
          }
          return merge({}, element, {active: false,subOptions:subOptions});
        });

      this.optionsSource.next(this.currentOptionsState);

    }


    changeSubOptionsState(name: string) {
      this.changeActiveSubCategory(name);
    }

    private changeActiveSubCategory(category: string) {
      this.currentOptionsState = OPTIONS.map(element => {
          let mainCat=null;
          let subOptions = element.subOptions.map( tmp => {
            if(!tmp.iconElement){
              
              // tmp.iconElement=new Image;
              // tmp.iconElement.src=tmp.icon;
            }   
            if (tmp.staticName === category) {
                mainCat=true;
              return merge({}, tmp, {active: true});
            }
            return tmp;
          });
          if(mainCat)
            element.active=true;
          else
            element.active=false;

          return merge({}, element, {subOptions: subOptions});
      });

        this.optionsSource.next(this.currentOptionsState);
  }

  toggleAction(target:string){    
    let currentActive=this.getActionByName(target);
    ;
    let toggle:boolean;
    if(currentActive)
      toggle=!currentActive.active;
    else
      toggle=true
      
      this.change(target, 'active', toggle)

      return toggle;
  }

  preloadOptionsIcons(){
    // if(this._currentOptionsState)
    //   for(let i=0;i<this._currentOptionsState.length;i++){
    //     if(this._currentOptionsState[i].subOptions)
    //       for(let j=0;j<this._currentOptionsState[i].subOptions.length;j++){
    //         if(!this._currentOptionsState[i].subOptions[j].iconElement){
              // this._currentOptionsState[i].subOptions[j].iconElement=new Image;
              // this._currentOptionsState[i].subOptions[j].iconElement.src=this._currentOptionsState[i].subOptions[j].icon;
      //       }      
      //     } 
      // }
    
    // this.optionsSource.next(this.currentOptionsState);
  }

  constructor() { 
    this.currentOptionsState=OPTIONS;
    // this.preloadOptionsIcons();
  }
}
